import CareGapsV2Page from "./pages/CareGapsV2Page";

export default CareGapsV2Page;
